var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircuitSwitchClosed = function SvgCircuitSwitchClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 9a3 3 0 0 0-2.828 2H2a1 1 0 1 0 0 2h1.172a3 3 0 0 0 5.656 0h6.344a2.999 2.999 0 0 0 5.656 0H22a1 1 0 1 0 0-2h-1.172a2.999 2.999 0 0 0-5.656 0H8.828A3 3 0 0 0 6 9m11 3a1 1 0 1 0 2 0 1 1 0 0 0-2 0M7 12a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
    clipRule: "evenodd"
  })));
};
export default SvgCircuitSwitchClosed;